import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/components/base/base.component';
@Component({
  selector: 'app-student-declaration',
  templateUrl: './student-declaration.component.html',
  styleUrls: ['./student-declaration.component.scss'],
})
export class StudentDeclarationComponent extends BaseComponent
  implements OnInit {
  nameFile;
  fileBase64;
  checkInsert;
  ID;
  ID_he;
  Khoa_hoc;
  titleModal;
  Action = new FormGroup({
    Ten_hoat_dong: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
    Mo_ta: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
    Thoi_gian: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
    Diem: new FormControl(null, [Validators.required, Validators.min(0)]),
    Url_minhchung: new FormControl(null),
  });
  ngOnInit(): void {
    this.getTokenSV();
    this.getAll();
    this.getSinhVien();
  }
  getAll() {
    this.spinner.show();
    this.StudentService.GetAll(this.ID_sv, this.Token).subscribe((z) => {
      this.spinner.hide();
      this.dataTable = z.Data;
    });
  }
  getSinhVien() {
    this.spinner.show();
    this.StudentService.GetSinhVien(this.ID_sv, this.Token).subscribe((z) => {
      this.ID_he = z.ID_he;
      this.Khoa_hoc = z.Khoa_hoc;
    });
  }
  onSubmit() {
    this.submitted = true;
    if (this.Action.invalid) {
      return false;
    }
    var req = {
      ID_sinh_hoat_cong_dong: this.ID,
      ID_sv: this.ID_sv,
      ID_he: this.ID_he,
      Khoa_hoc: this.Khoa_hoc,
      Ten_hoat_dong: this.Action.controls.Ten_hoat_dong.value,
      Mo_ta: this.Action.controls.Mo_ta.value,
      Thoi_gian: this.Action.controls.Thoi_gian.value,
      Diem: this.Action.controls.Diem.value,
      fileBase64: this.fileBase64,
      nameFile: this.nameFile,
    };
    if (this.checkInsert) {
      if (this.fileBase64 == null || this.fileBase64 == '') {
        this.toastr.warning('Bạn chưa chọn file minh chứng');
        return false;
      }
      this.StudentService.Insert(req, this.Token).subscribe((res) => {
        this.modalService.dismissAll('AddModal');
        if (res.Status == 1) {
          this.getAll();
          this.toastr.success('Thêm mới thành công!');
        } else {
          this.toastr.warning(res.Message);
        }
      });
    } else {
      var param = {
        ID_sinh_hoat_cong_dong: this.ID,
        ID_sv: this.ID_sv,
        ID_he: this.ID_he,
        Khoa_hoc: this.Khoa_hoc,
        Ten_hoat_dong: this.Action.controls.Ten_hoat_dong.value,
        Mo_ta: this.Action.controls.Mo_ta.value,
        Thoi_gian: this.Action.controls.Thoi_gian.value,
        Diem: this.Action.controls.Diem.value,
        fileBase64: this.fileBase64,
        nameFile: this.nameFile,
        Trang_thai: 3,
      };
      this.StudentService.Update(param, this.Token).subscribe((res) => {
        this.modalService.dismissAll('AddModal');
        if (res.Status == 1) {
          this.getAll();
          this.toastr.success('Thêm mới thành công!');
        } else {
          this.toastr.warning(res.Message);
        }
      });
    }
  }
  open(content, sizm, type, data) {
    this.ID = data.ID_sinh_hoat_cong_dong;
    if (data != null && data != '') {
      if (data.Trang_thai == 1) {
        this.toastr.warning('Hoạt động đã duyệt không được sửa xóa');
        return false;
      }
    }
    this.submitted = false;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
    if (type == 'Add') {
      this.checkInsert = true;
      this.titleModal = 'Thêm mới sinh hoạt cộng đồng';
    } else {
      this.checkInsert = false;
      this.titleModal = 'Chỉnh sửa sinh hoạt cộng đồng';
      this.Action.controls.Ten_hoat_dong.setValue(data.Ten_hoat_dong);
      this.Action.controls.Mo_ta.setValue(data.Mo_ta);
      this.Action.controls.Thoi_gian.setValue(data.Thoi_gian);
      this.Action.controls.Diem.setValue(data.Diem);
      this.Action.controls.Url_minhchung.setValue(data.URL_minh_chung);
    }
  }
  get checkvalue() {
    return this.Action.controls;
  }
  Delete() {
    this.StudentService.Delete(this.ID, this.Token).subscribe((res) => {
      if (res.Status == 1) {
        this.getAll();
        this.toastr.success('Xoá thành công!');
      } else {
        this.toastr.warning(res.Message);
      }
      this.modalService.dismissAll('AddModal');
    });
  }
  Uploadfile(even) {
    let dataBase64: any;
    let fileReader = new FileReader();
    if (even.target.files[0]) {
      fileReader.readAsDataURL(even.target.files[0]);
    }
    fileReader.onloadend = (e) => {
      dataBase64 = fileReader.result;
      dataBase64 = dataBase64.split('base64,')[1];
      if (even.target.files[0].name.length > 100) {
        this.toastr.warning('Tên file không được vượt quá 100 kí tự!');
        return false;
      }
      if (!this.isImage(even.target.files[0].name)) {
        this.toastr.warning(
          'Vui lòng chọn tải file có định dạng .jpg, .PNG, .docx, PDF !'
        );
        return false;
      }
      if (even.target.files[0].size > 20971520) {
        this.toastr.warning('File không được quá 20MB!');
        return false;
      }
      this.fileBase64 = dataBase64;
      this.nameFile = even.target.files[0].name;
    };
  }
  isImage(filename) {
    var ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'png':
      case 'docx':
      case 'doc':
      case 'pdf':
      case 'zip':
      case 'rar':
        return true;
    }
    return false;
  }
  getExtension(filename) {
    var parts = filename.split('.');
    return parts[parts.length - 1];
  }
}
